import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import * as particles from "pixi-particles";
import * as TweenJS from "slotworks/utils/tween";
import {EndlessHover, BounceZoomOut} from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import deviceInfo from "slotworks/utils/device-info";
import Point from "slotworks/utils/geom/point";
import { sequence, parallel } from "slotworks/utils/race-utils";
import { CenterPivot, Ungroup } from "slotworks/graphics/pixi/group";
import GameState from "slotworks/model/game-state";
import betModel from "slotworks/model/bets/bet-model";
import Components from "slotworks/components/components";
import Timer from "slotworks/utils/timer";
import { setTimeout } from "timers";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";

export default class RevolverWinTransitions extends AbstractSceneTransition {
    public BOUNCE_TIME: number = 700;
    public HOVER_SCALE: number = 1.15;
    public HOVER_TIME: number = 1000;
    public EXPLODE_DURATION: number = 250;
    public TITLE_ZOOM_TWEEN = 1.2;
    
    protected static coins: particles.Emitter;

    protected static glowStack: PIXI.Sprite[] = [];
    protected static rainbowStack: PIXI.Sprite[] = [];
    protected static rainbowContainer: PIXI.Container;
    protected static glowContainer: PIXI.Container;
    protected static glowTweens: TweenJS.Tween[];

    protected static currentTiers: any[];

    protected static winValue: PIXI.BitmapText;

    protected static freespins: PIXI.Sprite;

    protected static background: PIXI.Sprite;

    protected zoomGroup: PIXI.Container;

    

    protected timers: number[] = [];

    protected inResolve: Function;    

    protected resolveIn() {
        if (this.inResolve) {
            this.inResolve();
        }

        this.inResolve = null;
    }

    public zoom(target: PIXI.Container,
        scaleFrom: number, scaleTo: number, duration: number, easing: (k: number) => number,
        pivot: Point = null): Contract<void> {

        return new Contract<void>((resolve) => {

            const group = CenterPivot(target, null, pivot);

            group.scale.set(scaleFrom, scaleFrom);

            const tween = new TweenJS.Tween(target.scale)
                .to({x: scaleTo, y: scaleTo}, duration)
                .easing(easing);
            tween.onComplete(() => {
                tween.onComplete(null);
                Ungroup(group);
                target.scale.set(scaleTo, scaleTo);
                resolve(null);
            });
            tween.start();
        });
    }

    // todo refactor
    protected zoomTextIn(middleScale: number, endScale: number): Contract<void> {
        return new Contract<void>(resolve=>{
            const target = RevolverWinTransitions.winValue;
            target.visible = true;
            TweenJS.removeAll(target.scale);
            target.scale.set(0, 0);
            new TweenJS.Tween(target.scale)
            .to({x: middleScale, y: middleScale}, 300)
            .onComplete(()=>{                
                TweenJS.removeAll(target.scale);
                new TweenJS.Tween(target.scale)
                .to({x: endScale, y: endScale}, 300)
                .onComplete(()=>{                   
                    TweenJS.removeAll(target.scale);
                    resolve(null);                    
                }).start();                
            }).start();
        });
    }

    protected explodeGlitter() {
        // this.resetEmitter(RevolverWinTransitions.glitter);

        // RevolverWinTransitions.glitter.emit = true;        

        // Timer.setTimeout(() => {
        //     RevolverWinTransitions.glitter.emit = false;
        // }, this.EXPLODE_DURATION);
    }

    protected explodeEmitter(emitter: particles.Emitter, duration: number) {
        // this.resetEmitter(emitter);

        // emitter.emit = true;

        // Timer.setTimeout(() => {
        //     emitter.emit = false;
        // }, duration);
    }

    protected clearTimers() {
        if (this.timers) {
            for (const timer of this.timers) {
                Timer.clearTimeout(timer);
            }
            this.timers = [];
        }
    }

    protected hoverTitle(title: PIXI.Sprite, repeats: number = 1) {
        TweenJS.removeAll(title.scale);
        new TweenJS.Tween(title.scale)
        .to({x: this.TITLE_ZOOM_TWEEN, y: this.TITLE_ZOOM_TWEEN}, 1000)
        .yoyo(true)
        .repeat(repeats)
        .onComplete(() => {
            this.zoom(title, title.scale.x, 0, 300, TweenJS.Easing.Sinusoidal.Out, new Point(0.5, 1)).then(
                () => {
                    title.visible = false;                                                    
                }
            )
        })
        .start(); 
    }

    protected hoverTitleBigWin(title: PIXI.Sprite, repeats: number = 1) {
        TweenJS.removeAll(title.scale);
        new TweenJS.Tween(title.scale)
        .to({x: this.TITLE_ZOOM_TWEEN, y: this.TITLE_ZOOM_TWEEN}, 850)
        .yoyo(true)
        .repeat(repeats)
        .onComplete(() => {
            this.zoom(title, title.scale.x, 0, 300, TweenJS.Easing.Sinusoidal.Out, new Point(0.5, 1)).then(
                () => {
                    title.visible = false;                                                    
                }
            )
        })
        .start(); 
    }

    protected titleIn(target: PIXI.Container, pivot: Point) {
        target.visible = true;
        return sequence([
            () => this.zoom(target, 0, 1.15, 300, TweenJS.Easing.Sinusoidal.Out, pivot),
            () => this.zoom(target, 1.15, 1, 300, TweenJS.Easing.Sinusoidal.Out, pivot)
        ]); 
    }

    protected titleOut(target: PIXI.Container, pivot: Point, time: number) {
        return this.zoom(target, 1, 0, time, TweenJS.Easing.Sinusoidal.Out, pivot);
    }

    protected introduce(target: PIXI.Container, duration: number, pivot: Point, startSize: number = 0) {
        return sequence([
            () => this.zoom(target, startSize, 1.2, duration * 0.75, TweenJS.Easing.Sinusoidal.Out, pivot),
            () => this.zoom(target, 1.2, 1, duration * 0.25, TweenJS.Easing.Sinusoidal.Out, pivot)
        ]);
    }

    protected resetEmitter(emitter: particles.Emitter) {
        emitter.emit = false;
        emitter.cleanup();
    }

    protected setTextSize(scale: number) {
        const target = RevolverWinTransitions.winValue;
        TweenJS.removeAll(target.scale);
        let width = this.getWidth();
        if(target.width*scale/target.scale.x > width) {
            target.width = width;
            target.scale.y = target.scale.x;
        }
        else {
            target.scale.y = target.scale.x = scale;    
        }
    }

    protected groupAndAnimateOut(target: PIXI.Container) {
        return new Contract<void>((resolve) => {
            try {
                sequence([
                    () => Contract.wrap(() => {
                        Layers.CelebrationForeground.add(target, false, true);
                    //    this.zoomGroup = CenterPivot([target, RevolverWinTransitions.winText], "zoomGroup");
                        this.zoomGroup = CenterPivot(target, "zoomGroup");
                        TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                        TweenJS.removeAll(RevolverWinTransitions.winValue);
                    }),
                    () => parallel([
                        () => BounceZoomOut(this.zoomGroup, this.BOUNCE_TIME),
                        // () => this.zoom(RevolverWinTransitions.winValue, RevolverWinTransitions.winValue.scale.x, 0, this.BOUNCE_TIME, TweenJS.Easing.Back.In)
                    ]),
                    () => Contract.wrap(() => {
                        Ungroup(this.zoomGroup, "zoomGroup");
                        Layers.CelebrationContent.add(target, false, false);

                        this.zoomGroup = null;
                    })
                ]).then(() => resolve(null));

            } catch (error) {
                target.visible = false;
                resolve(null);
            }
        });
    }

    private getWidth() {
        let width = 1920;
        if(deviceInfo.isPhone && document.getElementById("portrait").style.display == "block")
        {
            width /= 1; //CANVAS_SIZES.DEFAULT_PORTRAIT_SCALE;
        }
        return width - 40;
    }

    protected endlessHover(topItem: PIXI.Container): TweenJS.Tween {
        let tween = EndlessHover(CenterPivot(topItem, null, new Point(0.5, 1)), this.HOVER_SCALE, this.HOVER_TIME);
    //    RevolverWinTransitions.winTextHover = EndlessHover(CenterPivot(RevolverWinTransitions.winText, null, new Point(0.5, 1)), this.HOVER_SCALE, this.HOVER_TIME, this.BOTTOM_LINE_DELAY);
        return tween;
    }

    protected endlessHoverFreespins(topItem: PIXI.Container): TweenJS.Tween {
        let tween = EndlessHover(CenterPivot(topItem, null, new Point(0.5, 1)), this.HOVER_SCALE, this.HOVER_TIME);
    //    RevolverWinTransitions.winTextHover = EndlessHover(CenterPivot(RevolverWinTransitions.winText, null, new Point(0.5, 1)), this.HOVER_SCALE, this.HOVER_TIME, this.BOTTOM_LINE_DELAY);
        return tween;
    }

    protected startGlowStack() {
        RevolverWinTransitions.glowTweens = [];
        RevolverWinTransitions.glowTweens.push(
            new TweenJS.Tween(CenterPivot(RevolverWinTransitions.glowStack[0]))
            .to({ rotation: Math.PI * 2 }, 20000)
            .repeat(Infinity)
            .start());
        
        RevolverWinTransitions.glowTweens.push(
            new TweenJS.Tween(CenterPivot(RevolverWinTransitions.glowStack[1]))
            .to({ rotation: -Math.PI * 2 }, 30000)
            .repeat(Infinity)
            .start());
        
        RevolverWinTransitions.glowTweens.push(
            new TweenJS.Tween(CenterPivot(RevolverWinTransitions.glowStack[2]))
            .to({ rotation: Math.PI * 2 }, 60000)
            .repeat(Infinity)
            .start());
    }

    protected zoomInStacks(time: number = 350, rainbowScale: number = 3.2, glowScale: number = 2.55) {
        this.startRainbowStack(); 
        RevolverWinTransitions.rainbowContainer.scale.set(0, 0);

        RevolverWinTransitions.glowContainer = CenterPivot(RevolverWinTransitions.glowStack.slice().reverse());
        this.startGlowStack();
        RevolverWinTransitions.glowContainer.scale.set(0, 0);

        return parallel([
            () => new Contract(resolve => {
                new TweenJS.Tween(RevolverWinTransitions.rainbowContainer.scale)
                .to({x: 1.5, y: 1.5}, time)
                .chain(
                    new TweenJS.Tween(RevolverWinTransitions.rainbowContainer.scale)
                    .to({x: rainbowScale, y: rainbowScale}, time)
                    .onComplete(() => { resolve(null) }))            
                .start();
            }),
            () => new Contract(resolve => {
                new TweenJS.Tween(RevolverWinTransitions.glowContainer.scale)
                .to({x: 3.2, y: 3.2}, time)
                .chain(
                    new TweenJS.Tween(RevolverWinTransitions.glowContainer.scale)
                    .to({ x: glowScale, y: glowScale}, time)
                    .onComplete(() => { resolve(null) }))            
                .start();
            })
        ]);
    }

    // todo refactor
    protected zoomInStacksJackpot(time: number = 400, glowScale: number = 4, rainbowScale: number = 5.5) {        
        RevolverWinTransitions.glowContainer = CenterPivot(RevolverWinTransitions.glowStack.slice().reverse());
        this.startGlowStack();
        RevolverWinTransitions.glowContainer.scale.set(0, 0);

        this.startRainbowStack(); 
        RevolverWinTransitions.rainbowContainer.scale.set(0, 0);

        return parallel([
            () => new Contract(resolve => {
                new TweenJS.Tween(RevolverWinTransitions.rainbowContainer.scale)
                .to({x: rainbowScale, y: rainbowScale}, time)
                .onComplete(() => { resolve(null) })            
                .start();
            }),
            () => new Contract(resolve => {
                new TweenJS.Tween(RevolverWinTransitions.glowContainer.scale)
                .to({x: glowScale, y: glowScale}, time)
                .onComplete(() => { resolve(null) })            
                .start();
            })
        ]);
    }

    protected zoomOutStacks() {
        return sequence([
            () => new Contract(resolve => {
                new TweenJS.Tween(RevolverWinTransitions.glowContainer.scale)
                .to({x: 8, y: 8}, 180)
                .onComplete(() => {
                    resolve(null);                    
                }).start();
                this.stopRainbowStack();
                RevolverWinTransitions.rainbowStack.forEach(element => {
                    element.x = RevolverWinTransitions.rainbowContainer.x;
                    element.y = RevolverWinTransitions.rainbowContainer.y;
                    Layers.CelebrationBackground.container.addChild(element);
                    element.visible = false;
                });                
            }),
            () => new Contract(resolve => {
                new TweenJS.Tween(RevolverWinTransitions.glowContainer.scale)
                .to({x: 0, y: 0}, 80)
                .onComplete(() => {
                    this.stopGlowStack();
                    RevolverWinTransitions.glowStack.forEach(element => {
                        element.x = RevolverWinTransitions.glowContainer.x;
                        element.y = RevolverWinTransitions.glowContainer.y;
                        Layers.CelebrationBackground.container.addChild(element);
                        element.visible = false;
                    });
                    resolve(null);
                }).start();                
            })
        ]);
    }

    protected stopRainbowStack() {
        RevolverWinTransitions.rainbowStack.forEach(element => {
            TweenJS.removeAll(element);
            TweenJS.removeAll(element.scale);
        });
    }

    protected stopGlowStack() {
        RevolverWinTransitions.glowTweens.forEach(tween => {
            tween.stop();
        });
        RevolverWinTransitions.glowTweens = [];
    }

    public getSelectedTiers(freespins: boolean = false): any[] {
        let winnings;
        if(freespins) {
            winnings = GameState.getCurrentGame().getRunningFreespinsWinTotal();
        } else if (GameState.getCurrentGame().getCurrentRecord().beenPaid || GameState.getCurrentGame().getCurrentRecord() instanceof FreespinRecord)  {
            winnings = GameState.getCurrentGame().totalCreditsWon;
        } else {
            winnings = GameState.getCurrentGame().getCurrentRecord().creditsWon;
        }
        
        const stake = betModel.getTotalBet();

        const multiplier = winnings / stake;

        const selectedLevels: any[] = [];
        let tiers = Components.config.bigWin.tiers;
        for (const level of tiers) {
            if (level.threshold > multiplier) {
                break;
            } else {
                selectedLevels.push(level);
            }
        }

        return selectedLevels;
    }

    protected startRainbowStack() {
        const time = 1000;

        const startTween = (item: PIXI.Sprite, time: number) => {
            setTimeout(() => {
                item.alpha = 0.8;
                item.scale.set(0.5, 0.5);
                new TweenJS.Tween(item)
                .to({alpha: 0.1}, time)
                .repeat(Infinity)
                .start();
                new TweenJS.Tween(item.scale)
                .to({x: 1, y: 1}, time)
                .repeat(Infinity)
                .start();
            }, time);
        }
        RevolverWinTransitions.rainbowContainer = CenterPivot(RevolverWinTransitions.rainbowStack);                   
        for(let itemId = 0; itemId < RevolverWinTransitions.rainbowStack.length; itemId++) {
            const item = RevolverWinTransitions.rainbowStack[itemId];
            item.anchor.set(0.5, 0.5);
            item.x += item.width * 0.5;
            item.y += item.height * 0.5;
            const scale:number = (itemId + 1) / 6;
            item.scale.set(scale, scale);
            item.alpha = 1 - scale + 0.1;
            startTween(item, itemId * time);
        }
        
    }

    protected resetBasic() {
        RevolverWinTransitions.background = Layers.CelebrationBackground.getSprite("fullscreen");

        RevolverWinTransitions.winValue = Layers.CelebrationForeground.getBitmapText("value");
    }

    protected resetEverything() {        
        RevolverWinTransitions.background = Layers.CelebrationBackground.getSprite("fullscreen");
        RevolverWinTransitions.coins = Layers.CelebrationBackground.getParticle("coins");
        RevolverWinTransitions.coins.emit = false;

        RevolverWinTransitions.winValue = Layers.CelebrationForeground.getBitmapText("value");

        RevolverWinTransitions.glowStack = [];
        // RevolverWinTransitions.glowStack.push(Layers.CelebrationBackground.getSprite("ic_hd_glow_1"));
        // RevolverWinTransitions.glowStack.push(Layers.CelebrationBackground.getSprite("ic_hd_glow_2"));
        // RevolverWinTransitions.glowStack.push(Layers.CelebrationBackground.getSprite("ic_hd_glow_3"));
        // RevolverWinTransitions.glowStack.push(Layers.CelebrationBackground.getSprite("ic_hd_glow_4"));

        RevolverWinTransitions.rainbowStack = [];
        // RevolverWinTransitions.rainbowStack.push(Layers.CelebrationBackground.getSprite("ic_hd_win_circle_red"));
        // RevolverWinTransitions.rainbowStack.push(Layers.CelebrationBackground.getSprite("ic_hd_win_circle_yellow"));
        // RevolverWinTransitions.rainbowStack.push(Layers.CelebrationBackground.getSprite("ic_hd_win_circle_green"));
        // RevolverWinTransitions.rainbowStack.push(Layers.CelebrationBackground.getSprite("ic_hd_win_circle_cyan"));
        // RevolverWinTransitions.rainbowStack.push(Layers.CelebrationBackground.getSprite("ic_hd_win_circle_blue"));
        // RevolverWinTransitions.rainbowStack.push(Layers.CelebrationBackground.getSprite("ic_hd_win_circle_purple"));

    }

    
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/revolver-win-transitions.ts